import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { StorageService } from '../services/storage.service';

@Injectable()
export class AppUrl {
  static get STUDENT_URL(): string {
    return environment.appUrl + 'student/';
  }

  static get REGISTER(): string {
    return AppUrl.STUDENT_URL + 'entrance-register';
  }

  static get OTP(): string {
    return AppUrl.STUDENT_URL + 'entrance-otp';
  }

  static get LOGIN(): string {
    return AppUrl.STUDENT_URL + 'entrance-login';
  }

  static get SELF(): string {
    return AppUrl.STUDENT_URL + 'entrance-self';
  }

  static get GET_QUESTIONS(): string {
    return AppUrl.STUDENT_URL + 'entrance-question';
  }

  static get ATTEND_EXAM(): string {
    return AppUrl.STUDENT_URL + 'entrance-attempt';
  }

  static get SYNC_ANSWERS(): string {
    return AppUrl.STUDENT_URL + 'entrance-question';
  }

  static get GET_ATTEMPTED_QUESTIONS(): string {
    return AppUrl.STUDENT_URL + 'entrance-question-attempted';
  }

  static get ATTEND_EXAM_FEEDBACK(): string {
    return AppUrl.STUDENT_URL + 'entrance-attempt-feedback';
  }

  static get EXAM_DETAIL(): string {
    return AppUrl.STUDENT_URL + 'entrance-attempt-detail';
  }

  static get PCB_MAPPING(): string {
    return AppUrl.STUDENT_URL + 'pcb-mapping';
  }
}
